export const checkInFactReducer = (state = false, action) => {
  switch (action.type) {
    case "INFACT":
      state = action.payload;
      return state;

    default:
      return state;
  }
};
export const ADDFactsIdReducer = (state = [], action) => {
  // console.log(state , 'is final fact id');
  switch (action.type) {
    case "ADDFACTSID":
      state = action.payload;
      return state;

      default:
        return state;
      }
    };
export const TicketsIdReducer = (state = 0, action) => {
  // console.log(state , 'is final tickets id');
  switch (action.type) {
    case "TICKETSID":
      state = action.payload;
      // window.localStorage.setItem("tickets_id",action.payload)
      return state;
      
    default:
      return state;
    }
};

export const PlantIDReducer = (state = null, action) => {
  switch (action.type) {
    case "PLANTID":
      state = action.payload;
      return state;

    default:
      return state;
  }
};
